import { CASE_SET_LAST_SELECTED_FILE, CASE_CLEAR_LAST_SELECTED_FILE, CASE_SET_LAST_SELECTED_BUNDLE } from './constants';

export function setLastSelectedFile(file, category, bundle) {
  return {
    type: CASE_SET_LAST_SELECTED_FILE,
    payload: { file, category, bundle },
  };
}

export function clearLastSelectedFile() {
  return {
    type: CASE_CLEAR_LAST_SELECTED_FILE,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case CASE_SET_LAST_SELECTED_FILE:
      return {
        ...state,
        lastSelectedFile: action.payload.file,
        lastSelectedCategory: action.payload.category,
        lastSelectedBundle: action.payload.bundle || state.lastSelectedBundle,
      };
    case CASE_SET_LAST_SELECTED_BUNDLE:
      return {
        ...state,
        lastSelectedBundle: action.payload,
      };
    case CASE_CLEAR_LAST_SELECTED_FILE:
      return {
        ...state,
        lastSelectedFile: null,
        lastSelectedCategory: null,
        lastSelectedBundle: null,
      };
    default:
      return state;
  }
}


